import { fetchService } from "@/core/services/fetch-service";
import IBadgeModel from "../models/badge-model";

export default class HomeService {
	public getBadges(): Promise<IBadgeModel[]> {
		return fetchService.get<IBadgeModel[]>("/Menu/Badges");
	}
}

export const homeService = new HomeService();